import { SurfaceBlockComponent } from './surface-block.js';
import { SurfaceBlockVoidComponent } from './surface-block-void.js';

export function effects() {
  customElements.define('hive-surface-void', SurfaceBlockVoidComponent);
  customElements.define('hive-surface', SurfaceBlockComponent);
}
